// Size Style Plugin
import { createSimpleProperty } from './helpers.js';

export default {
    id: 'size',
    label: 'Size',
    icon: 'Maximize',
    properties: {
        width: {
            label: 'Width',
            type: 'select',
            options: ['auto', 'full', 'screen', 'min', 'max', 'fit', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96', '1/2', '1/3', '2/3', '1/4', '2/4', '3/4', '1/5', '2/5', '3/5', '4/5', '1/6', '2/6', '3/6', '4/6', '5/6', '1/12', '2/12', '3/12', '4/12', '5/12', '6/12', '7/12', '8/12', '9/12', '10/12', '11/12'],
            default: 'auto',
            ...createSimpleProperty('w')
        },
        minWidth: {
            label: 'Min Width',
            type: 'select',
            options: ['0', 'full', 'min', 'max', 'fit'],
            default: '0',
            ...createSimpleProperty('min-w'),
            toClass: (value) => {
                if (!value) return null;
                const options = ['0', 'full', 'min', 'max', 'fit'];
                if (options.includes(value)) return `min-w-${value}`;
                return `min-w-[${value}]`;
            }
        },
        maxWidth: {
            label: 'Max Width',
            type: 'select',
            options: ['none', '0', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'full', 'min', 'max', 'fit', 'prose', 'screen-sm', 'screen-md', 'screen-lg', 'screen-xl', 'screen-2xl'],
            default: 'none',
            ...createSimpleProperty('max-w'),
            toClass: (value) => {
                if (!value) return null;
                const options = ['none', '0', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'full', 'min', 'max', 'fit', 'prose', 'screen-sm', 'screen-md', 'screen-lg', 'screen-xl', 'screen-2xl'];
                if (options.includes(value)) return `max-w-${value}`;
                return `max-w-[${value}]`;
            }
        },
        height: {
            label: 'Height',
            type: 'select',
            options: ['auto', 'full', 'screen', 'min', 'max', 'fit', '0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96', '1/2', '1/3', '2/3', '1/4', '2/4', '3/4', '1/5', '2/5', '3/5', '4/5', '1/6', '2/6', '3/6', '4/6', '5/6'],
            default: 'auto',
            ...createSimpleProperty('h')
        },
        minHeight: {
            label: 'Min Height',
            type: 'select',
            options: ['0', 'full', 'screen', 'min', 'max', 'fit'],
            default: '0',
            ...createSimpleProperty('min-h'),
            toClass: (value) => {
                if (!value) return null;
                const options = ['0', 'full', 'screen', 'min', 'max', 'fit'];
                if (options.includes(value)) return `min-h-${value}`;
                return `min-h-[${value}]`;
            }
        },
        maxHeight: {
            label: 'Max Height',
            type: 'select',
            options: ['none', '0', 'full', 'screen', 'min', 'max', 'fit', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '20', '24', '28', '32', '36', '40', '44', '48', '52', '56', '60', '64', '72', '80', '96'],
            default: 'none',
            ...createSimpleProperty('max-h')
        }
    }
};
